"use client";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import { cn } from "@/utils";
import CloseIcon from "@/components/atoms/icons/CloseIcon";
import { useTranslation } from "react-i18next";

type PopupPromotionProps = {
  imageUrl: string;
  linkFanpage: string;
  isHideButton?: boolean;
};

const PopupPromotion: React.FC<PopupPromotionProps> = ({
  imageUrl,
  linkFanpage,
  isHideButton = false,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={cn(
        "fixed -left-4 bottom-4 z-40 transition-all duration-300 transform",
        isOpen ? "translate-x-0 left-4" : "-translate-x-full"
      )}
    >
      <button
        className="absolute z-50 top-1 right-1 w-6 h-6 md:w-8 md:h-8 flex items-center justify-center"
        onClick={() => setIsOpen(false)}
        aria-label="Close promotion"
      >
        <CloseIcon />
      </button>
      <Link
        href={linkFanpage}
        target="_blank"
        className="w-[280px] md:w-[480px] lg:w-[520px] h-auto min-h-fit bg-primary relative rounded-lg
                overflow-hidden shadow-lg hover:shadow-xl transition-shadow
                p-2 md:p-4 opacity-95 flex flex-col"
      >
        <div className="p-2 md:p-4 flex items-center justify-center">
          <Image
            src={imageUrl}
            alt="Promotion"
            width={1280}
            height={720}
            priority={true}
            className="aspect-video w-3/4 md:w-full object-cover"
          />
        </div>
        {!isHideButton && (
          <div className="flex flex-col gap-4 items-center justify-center">
            <button className="bg-rose text-white py-1 md:py-2 px-2 md:px-4 rounded-lg text-sm md:text-base w-full">
              {t("home.popup_promotion.cta_button")}
            </button>
          </div>
        )}
      </Link>
    </div>
  );
};

export default PopupPromotion;
